import { useState, useEffect } from 'react';
import { Box, Typography, TextField, Button, Card, CardContent } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { getProjectDescription, postProjectDescription } from '../../../../../actions/tigercat-burns/tigercat-base-actions';

const EligibilityRequirements = ({ projectId }) => {
    const dispatch = useDispatch();
    const [data, setData] = useState({ eligibility_monitoring: '' });

    const eligibilityData = useSelector(state => state.tigercatBurnsBaseReducer.projectDescription.data);

    const handleSave = () => {
        dispatch(postProjectDescription(projectId, 'eligibility', data));
    };

    useEffect(() => {
        dispatch(getProjectDescription(projectId, 'eligibility'));
    }, [projectId, dispatch]);

    useEffect(() => {
        if (eligibilityData && typeof eligibilityData.eligibility_monitoring === 'string') {
            setData({ eligibility_monitoring: eligibilityData.eligibility_monitoring });
        }
    }, [eligibilityData]);

    return (
        <Card sx={{ maxWidth: '800px', mx: 'auto', mt: 4 }}>
            <Box sx={{ ml: 2 }}>
                <h2>Eligibility Requirements</h2>
            </Box>
            <CardContent>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    Provide a description of how the project will be monitored with respect to eligibility requirements.
                    Include procedures that the project developer will follow to ascertain and demonstrate that the
                    project at all times passes the legal requirement test and maintains regulatory compliance.
                    Also include a description of any new ecosystem services payments stacking and/or project stacking
                    will be identified.
                </Typography>

                <TextField
                    fullWidth
                    multiline
                    minRows={4}
                    placeholder="Add text"
                    value={data.eligibility_monitoring}
                    onChange={(e) => setData({ eligibility_monitoring: e.target.value })}
                    sx={{ mb: 3 }}
                />

                <Button variant="contained" onClick={handleSave}>
                    Save
                </Button>
            </CardContent>
        </Card>
    );
};

export default EligibilityRequirements;